import { Show, type Component } from "solid-js";
import { PanelLayout } from "@/shared/panel-base";
import { PluginPanelHost, type OnPanelAction } from "@/shared/plugin-panel-host";
import { useWs } from "@/shared/ws";
import { registerPanel } from "@/panel-registry";

/**
 * Wrapper partagé pour les sous-panels network. Tous consomment le même plugin
 * `network` mais demandent une `view` différente (voir plugins/network/panel/index.js).
 */
export function NetworkView(props: { title: string; view: string; onAction?: OnPanelAction }) {
  const ws = useWs();
  const version = () => ws.state.pluginVersions["network"];

  return (
    <PanelLayout title={props.title}>
      <Show
        when={version()}
        fallback={
          <div class="panel-data-empty" style={{ opacity: "0.5" }}>
            Plugin Network non disponible sur ce host (plugin non chargé).
          </div>
        }
      >
        {(v) => (
          <div style={{ padding: "0.25rem 0", "font-size": "0.72rem", opacity: "0.5", "margin-bottom": "0.25rem" }}>
            Plugin v{v()}
          </div>
        )}
      </Show>
      <Show when={version()}>
        <PluginPanelHost pluginId="network" view={props.view} onAction={props.onAction} />
      </Show>
    </PanelLayout>
  );
}

const NetworkPanel: Component = () => <NetworkView title="Network" view="main" />;

registerPanel("network", NetworkPanel);
export default NetworkPanel;
